import { TimeIcon } from "@chakra-ui/icons";
import {
  Box,
  Input,
  InputGroup,
  InputRightElement,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type TimePickerProps = {
  value: Date | null;
  onChange: (date: Date | null) => void;
};

export const TimePicker: React.FC<TimePickerProps> = ({ value, onChange }) => {
  const [selectedTime, setSelectedTime] = useState<Date | null>(value);

  return (
    <Box
      width="100%"
      sx={{
        ".date-picker-full-width": { width: "100%" },
        ".react-datepicker-popper": { width: "100%" },
        ".react-datepicker--time-only": { width: "100%" },
        ".react-datepicker__time-container": { width: "100%" },
        ".react-datepicker__time-container .react-datepicker__time": {
          width: "100%",
        },
        ".react-datepicker__time-box": { width: "100% !important" },
      }}
    >
      <VStack alignItems="stretch" zIndex={1} position="relative" width="100%">
        <InputGroup>
          <DatePicker
            selected={selectedTime}
            onChange={(date) => {
              setSelectedTime(date);
              onChange(date);
            }}
            customInput={<Input />}
            showTimeSelectOnly
            showTimeSelect
            dateFormat="h:mm aa"
            placeholderText="Select a time"
            timeIntervals={30}
            wrapperClassName="date-picker-full-width"
          />
          <InputRightElement pointerEvents="none">
            <TimeIcon fontSize="sm" />
          </InputRightElement>
        </InputGroup>
      </VStack>
    </Box>
  );
};
